import { render, staticRenderFns } from "./Ringtone.vue?vue&type=template&id=314253fb&scoped=true&"
import script from "./Ringtone.vue?vue&type=script&lang=js&"
export * from "./Ringtone.vue?vue&type=script&lang=js&"
import style0 from "./Ringtone.vue?vue&type=style&index=0&id=314253fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314253fb",
  null
  
)

export default component.exports